import {get, post, put, del, getExel, postById, putById, getById, postExel} from './base'

// /api/admin/getYCompanyPayConfig

export function getYCompanyPayConfig () {
  return getById('/api/admin/getYCompanyPayConfig')
}
export function setCompanyConfig (data) {
  return postById('/api/admin/setCompanyConfig', data)
}
